import React, { useState, useEffect } from "react";
import { Button } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { Row } from "react-bootstrap";
import "./Preview.css";

const Preview = ({ anexo, handleDelete }) => {
  const [url, setUrl] = useState(null);

  useEffect(() => {
    if (anexo) {
      const newUrl = isBase64(anexo) 
        ? URL.createObjectURL(base64toBlob(anexo))
        : URL.createObjectURL(anexo);

      setUrl(newUrl);

      return () => {
        URL.revokeObjectURL(newUrl);
      };
    }
  }, [anexo]);

  const isBase64 = (str) => {
    const base64Regex =
      /^(data:(image\/[a-zA-Z]*|application\/pdf);base64,)?([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{4}|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)$/;
    return base64Regex.test(str);
  };

  const base64toBlob = (base64) => {
    const base64Parts = base64.split(";base64,");
    const contentType = base64Parts[0].split(":")[1];
    const byteCharacters = atob(base64Parts[1]);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const blob = new Blob([new Uint8Array(byteNumbers)], { type: contentType });
    return blob;
  };

  const getPreview = (url, anexo) => {
    if (!url) return null;
    
    if (isBase64(anexo)) {
      if (anexo.startsWith("data:application/pdf")) {
        return <iframe src={url} width="100%" height="500px" title="PDF Preview"></iframe>;
      } else if (anexo.startsWith("data:image/")) {
        return <img className="image mt-3 mb-3" width="100%" src={url} alt="anexo" />;
      }
    } else {
      if (anexo.type === "application/pdf") {
        return <iframe src={url} width="100%" height="500px" title="PDF Preview"></iframe>;
      } else if (anexo.type.startsWith("image/")) {
        return <img className="image mt-3 mb-3" width="100%" src={url} alt="anexo" />;
      }
    }
    return null;
  };

  return (
    <Row className="text-center justify-content-center mt-3 pl-3 pr-3">
      {/* <Col md={8} className="mt-3 mb-3"> */}
        {getPreview(url, anexo)}
        <Button className="ml-3 mr-3 mt-3" color="error" variant="outlined" onClick={handleDelete}>
          <DeleteIcon />
          Excluir
        </Button>
      {/* </Col> */}
    </Row>
  );
};

export default Preview;
